<template>
  <div class="liu">
    <!-- 顶部 -->
    <mt-header fixed :title="title" class="title2">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <!-- 正文 -->
    <div class="scroll-container">
      <!-- 列表 -->
      <div class="agent-push-box">
        <div class="agent-push center">
          <span class="fee-info-box">流量费(元/台)</span>
          <input type="text" v-model="fee" maxlength="10" :placeholder="placeholder" :readonly="!btnVisible" @input="onFlowCostInput" />
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="button-list" v-if="btnVisible">
      <mt-button type="primary" size="large" @click="onSubmitBtnClick">
        提交
      </mt-button>
    </div>
  </div>
</template>

<script>
import { Indicator, MessageBox } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { GetUserMaxFlowRateFeeMsg, SetUserFlowRateFee } from '@/api/agent';

export default {
  name: 'FlowCostList',
  data() {
    return {
      id: this.$route.query.id || null,
      type: this.$route.query.type || '0',
      name: this.$route.query.name || '',
      placeholder: this.$route.query.placeholder || '',
      fee: this.$route.query.fee || null,
      myParam: {
        productAgentId: '',
        smsYearFeeSplitMoney: 0,
      },
    };
  },
  computed: {
    title() {
      return '流量费设置' + (this.name ? ' - ' + this.name : '');
    },
    btnVisible() {
      if (this.type === '1') return false;
      if (this.type === '2') return true;
      return true;
    },
  },
  methods: {
    // 验证输入的流量费
    validateFee() {
      if (!this.fee) {
        CusToast('请输入数字');
        return 'err';
      }
      const feeArr = String(this.fee).split('.');
      if (feeArr.length > 2) {
        CusToast('非法数字');
        return 'err';
      }
      if (feeArr[1] && feeArr[1].length > 2) {
        CusToast('只能保留两位小数');
        return 'err';
      }
      return 'ok';
    },
    // 返回格式化好的流量费
    getOkFee() {
      let result = '';
      const feeArr = String(this.fee).split('.');
      result = feeArr.length > 1 ? (feeArr[1].length > 1 ? feeArr[0] + feeArr[1] : feeArr[0] + feeArr[1] + '0') : feeArr[0] + '00';
      return result;
    },
    // 流量费输入框input事件
    onFlowCostInput() {
      const last = this.fee.charAt(this.fee.length - 1);
      // 自动将非法字符替换成空
      this.fee = '1234567890.'.indexOf(last) < 0 ? this.fee.replace(last, '') : this.fee;
      // 自动将汉字符替换成空
      this.fee = this.fee.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 设置代理商流量费
    setUserFlowRateFee(indicator) {
      SetUserFlowRateFee(this.myParam)
        .then(res => {
          indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              const toast = CusToast('设置成功', 5000);
              setTimeout(() => {
                toast.close();
                this.$router.go(-1);
              }, 1200);
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 提示按钮单击事件
    onSubmitBtnClick() {
      if (this.validateFee() === 'err') return;
      Indicator.open();
      this.myParam.productAgentId = this.id;
      this.myParam.smsYearFeeSplitMoney = this.getOkFee();
      // 获取比较下级代理商流量费最大金额提示信息
      GetUserMaxFlowRateFeeMsg(this.myParam)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data.msg) {
                Indicator.close();
                MessageBox({
                  title: '',
                  message: res.data.msg,
                  showCancelButton: true,
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  confirmButtonHighlight: true,
                  confirmButtonClass: 'confirm-btn',
                }).then(action => {
                  // 点击确定
                  if (action === 'confirm') {
                    Indicator.open();
                    this.setUserFlowRateFee(Indicator);
                  }
                });
              } else {
                this.setUserFlowRateFee(Indicator);
              }
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
};
</script>
